// eslint-disable-next-line
const apiCache: { [url: string]: { data: any, date: Date } } = {};
const cacheMaxData = 2000;
const cacheDurationInS = 3600; // 1h

export const hasCache = (url: string): boolean => {
  if (!cacheDurationInS) {
    return !!apiCache[url];
  }
  const cache = apiCache[url];
  if (!cache) {
    return false;
  }
  const diffInMs = new Date().getTime() - cache.date.getTime();

  const diffInS = diffInMs / 1000;
  if (diffInS > cacheDurationInS) {
    delete apiCache[url];
    return false;
  }
  return true;
};

export const getCache = <T>(url: string): Promise<T> =>
  new Promise((resolve, reject) => {
    resolve(apiCache[url].data);
  });

export const insertCache = <T>(url: string, data: T): void => {
  if (Object.keys(apiCache).length > cacheMaxData) {
    const key = Object.keys(apiCache)
      .sort((a, b) => apiCache[a].date.getDate() - apiCache[b].date.getDate())[0];
    delete apiCache[key];
  }
  apiCache[url] = {
    data,
    date: new Date(),
  };
};
